import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    var containerEl = document.querySelector('.banner-slider');
    if (!containerEl) return;

    var slider = tns({
        container: containerEl,
        items: 1,
        slideBy: 1,
        nav: false,
        hasControls: true,
        autoplay: true,
        autoplayButtonOutput: false,
        prevButton: document.querySelector('.standard-banner .slick-arrow.left-arrow'),
        nextButton: document.querySelector('.standard-banner .slick-arrow.right-arrow'),
        speed: 300
    });
});
